// extracted by mini-css-extract-plugin
export default {"wrapper":"settlements_wrapper__sueV5","search":"settlements_search__i1kTO","client":"settlements_client__c-HNV"};